import React from "react";
import PropTypes from "prop-types";
import DataGrid, { DataGridItem } from "components/data-grid";
import { RecordingPaginatedTable } from "pages/recording";
import StartedRecordingTable from "./started-recordings-table";
import { eventStatusTypes } from "pages/event/utils";

const RecordingsData = ({ page, event }) => {
  if (event.eventStatus === eventStatusTypes.STARTED) {
    return (
      <DataGrid>
        <DataGridItem big>
          <StartedRecordingTable event={event} />
        </DataGridItem>
      </DataGrid>
    );
  }

  if (event.eventStatus === eventStatusTypes.FINISHED || event.eventStatus === eventStatusTypes.DELETED) {
    return (
      <DataGrid>
        <DataGridItem big>
          <RecordingPaginatedTable page={page} variables={{ eventId: event.id }} />
        </DataGridItem>
      </DataGrid>
    );
  }

  return null;
};

RecordingsData.propTypes = {
  /**
   * Page of table
   **/
  page: PropTypes.number,
  /**
   * Data to represent
   **/
  event: PropTypes.object,
};

export default RecordingsData;
